export default __webpack_public_path__ + "static/media/NCNepal.00be171b.png";